import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'

import CompanyRepository from '@/shared/http/repositories/configuration/company'
import CompanyLogoRepository from '@/shared/http/repositories/configuration/companylogo'
import ProfileRepository from '@/shared/http/repositories/access/profile'
import CompanyModel from '@/shared/models/configuration/companymodel'
import CompanyForms from './company-form'

const STATIC_URL = 'https://static.zopone.com.br/'
const TEXTOS = ['nome', 'nomeFantasia', 'cnpj', 'ie', 'localidade', 'descricao']

// ZC-89: o form casa com o JSON de Empresa. onEdit/onSave não passam pelo Tools.SetValueInForm/SetValueToSave —
// eles convertem texto só de dígitos (CNPJ, IE) em decimal.
export default {
  name: 'company',
  mixins: [ActionsForm],
  data () {
    return {
      data: CompanyModel,
      form: CompanyForms,
      enviandoLogo: false,
      filtro: { busca: '', selecionavel: null },
      opcoesSelecionavel: [
        { value: null, text: 'Selecionável: Todas' },
        { value: true, text: 'Selecionável: Sim' },
        { value: false, text: 'Selecionável: Não' }
      ]
    }
  },
  computed: {
    FieldSizeTip: function () {
      return this.$lang.Common.Tips.MaximumSize.replace('@SIZE@', this.form.descricao.maxlength)
    },
    logoURL () {
      return this.form.logo.value ? STATIC_URL + this.form.logo.value : null
    },
    editando () {
      return !!this.data.id && this.data.id !== '00000000-0000-0000-0000-000000000000'
    }
  },
  created () {
    this.carregarPerfis()
  },
  methods: {
    onLoad () {
      loading.push()
      CompanyRepository.GetAllPagingFiltro(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex, this.filtro.busca, this.filtro.selecionavel)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onFiltrar () {
      this.$refs.tableGrid.pagingIndex = 1
      this.onLoad()
    },
    carregarPerfis () {
      ProfileRepository.GetAll()
        .then((response) => {
          if (response.data.code > 0) {
            this.form.perfilAcessoID.options = response.data.data
              .filter(p => p.funcao && p.funcao.indexOf('ACC_COMPANY_') === 0)
              .map(p => ({ value: p.id, text: p.funcao.replace('ACC_COMPANY_', '') + ' — ' + p.nome }))
          }
        })
    },
    onEdit (obj) {
      for (const key in this.data) {
        this.data[key] = obj.hasOwnProperty(key) ? obj[key] : null
      }
      for (const key in this.form) {
        this.form[key].value = obj.hasOwnProperty(key) ? obj[key] : null
        this.form[key].state = null
      }
      this.form.selecionavel.value = !!obj.selecionavel
    },
    onSave () {
      let valido = true
      for (const key in this.form) {
        const f = this.form[key]
        if (f.required && (f.value === null || f.value === '')) {
          f.state = false
          valido = false
        } else {
          f.state = null
        }
      }
      if (!valido) {
        toast.warning(this.$lang.Common.Alerts.RequiredField)
        return
      }
      for (const key of TEXTOS) {
        const v = this.form[key].value
        this.data[key] = v === null || v === undefined || String(v).trim() === '' ? null : String(v).trim()
      }
      this.data.codigoZ = parseInt(this.form.codigoZ.value, 10)
      this.data.selecionavel = !!this.form.selecionavel.value
      this.data.perfilAcessoID = this.form.perfilAcessoID.value || null
      this.data.logo = this.form.logo.value || null
      if (this.data.percLimiteDespesa === null) this.data.percLimiteDespesa = 70
      if (this.editando) {
        this.onUpdate()
      } else {
        this.data.id = '00000000-0000-0000-0000-000000000000'
        this.data.status = 1
        this.onCreate()
      }
    },
    onCreate () {
      loading.push()
      CompanyRepository.Create(this.data)
        .then(this.onResult)
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      if (this.data.selecionavel === null) this.data.selecionavel = false
      if (this.data.percLimiteDespesa === null) this.data.percLimiteDespesa = 70
      CompanyRepository.Update(this.data)
        .then(this.onResult)
        .catch(this.onException)
    },
    onDelete (obj) {
      loading.push()
      CompanyRepository.Delete(obj.id)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLogoEscolhido (arquivo) {
      if (!arquivo) return
      if (!this.form.codigoZ.value) {
        toast.warning('Informe o Código Z antes de enviar o logo.')
        return
      }
      if (arquivo.size > 1024 * 1024) {
        toast.warning('Logo acima de 1 MB.')
        return
      }
      this.enviandoLogo = true
      CompanyLogoRepository.Upload(this.form.codigoZ.value, arquivo)
        .then((response) => {
          if (response.data.code > 0) {
            this.form.logo.value = response.data.data
          } else {
            toast.error('Não foi possível enviar o logo (PNG, JPG, WEBP ou SVG até 1 MB).')
          }
        })
        .catch(this.onException)
        .then(() => {
          this.enviandoLogo = false
        })
    },
    onLogoRemover () {
      this.form.logo.value = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/company/company.js